import { AppDispatch } from '../../store'
import api from './axiosClient'
import {
    GetAllUserAlertLogsResponse,
    GetAllUserAlertsResponse,
    UserAlert,
    UserAlertLog
} from '../../proto/generated/nexus'
import { setUserAlerts } from '../../reducer/alerts.reducer'
import { setUserAlertLogs } from '../../reducer/alertLogs.reducer'

export const fetchUserAlerts = async (args: { dispatch: AppDispatch }): Promise<UserAlert[]> => {
    return new Promise((resolve, reject) => {
        const url = `/user-alerts/all`
        api.get(url, {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const result = GetAllUserAlertsResponse.decode(new Uint8Array(response.data))
                args.dispatch(setUserAlerts(result.alerts))
                resolve(result.alerts)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const createAlert = async (body: any): Promise<UserAlert> => {
    return new Promise((resolve, reject) => {
        const url = `/user-alerts`
        api.post(url, JSON.stringify(body), {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const result = UserAlert.decode(new Uint8Array(response.data))
                resolve(result)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const stopAlert = async (args: { id: string }): Promise<UserAlert> => {
    return new Promise((resolve, reject) => {
        const url = `/user-alerts/${args.id}/stop`
        api.post(url, {}, {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const result = UserAlert.decode(new Uint8Array(response.data))
                resolve(result)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const restartAlert = async (args: { id: string }): Promise<UserAlert> => {
    return new Promise((resolve, reject) => {
        const url = `/user-alerts/${args.id}/restart`
        api.post(url, {}, {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const result = UserAlert.decode(new Uint8Array(response.data))
                resolve(result)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


export const removeAlert = async (args: { id: string }): Promise<void> => {
    return new Promise((resolve, reject) => {
        const url = `/user-alerts/${args.id}`
        api.request({
            url: url,
            headers: {
                Accept: 'application/x-protobuf'
            },
            method: 'DELETE',
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                resolve()
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const fetchUserAlertLogs = async (args: { dispatch: AppDispatch }): Promise<UserAlertLog[]> => {
    return new Promise((resolve, reject) => {
        const url = `/user-alert-logs/all`
        api.get(url, {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const result = GetAllUserAlertLogsResponse.decode(new Uint8Array(response.data))
                args.dispatch(setUserAlertLogs(result.alertLogs))
                resolve(result.alertLogs)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const removeAlertLog = async (args: { id: string }): Promise<void> => {
    return new Promise((resolve, reject) => {
        const url = `/user-alert-logs/${args.id}`
        api.request({
            url: url,
            headers: {
                Accept: 'application/x-protobuf'
            },
            method: 'DELETE',
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                resolve()
            })
            .catch((error) => {
                reject(error)
            })
    })
}